import * as React from 'react';
import { withNodeResizable } from '../shared/NodeResizable';
import { Portal } from '../shared/Portal';
import { createEmbedExtension } from '../shared/createEmbedExtension';
import { EmbedRendererProps } from '../shared/types';

const URL_REGEX = /^https:\/\/(www\.)?(use)?loom.com\/(embed|share)\/(.*)$/;
export const ENABLED = [URL_REGEX];

export const Component = ({ url, ...rest }: EmbedRendererProps<any>) => {
  const newUrl = React.useMemo(() => url.replace('share', 'embed'), [url]);

  return (
    <Portal {...rest} url={newUrl} title="Loom Embed" fullHeight withMetadata />
  );
};

export default createEmbedExtension({
  name: 'loom-embed',
  component: withNodeResizable(Component, {
    lockAspectRatio: true,
    defaultHeight: 500,
  }),
  addCommandOption: {
    title: 'Loom',
    description: 'Embed a Loom video.',
    searchTerms: ['embed', 'loom'],
    icon: 'logos:loom-icon',
  },
});
